/**
 * title Announcements
 * description Shows and hides the site's announcement.
 */
function announcements() {
  const announcementElement = document.querySelector('[data-js="announcements"]')

  if (document.body.contains(announcementElement)) {
    const announcementElementHeight = announcementElement.scrollHeight

    const dismissedAnnouncementsList = localStorage.getItem("dismissed-announcement")
    const announcementButton = document.querySelector('[data-js="announcements-dismiss"]')
    let announcementArray = JSON.parse(dismissedAnnouncementsList)
    const announcementId = announcementElement.getAttribute("data-js-announcements-id")

    if (announcementId) {
      announcementButton.addEventListener("click", function (e) {
        e.preventDefault()

        if (announcementArray === null) {
          announcementArray = []
        }

        announcementArray.push(announcementId)

        localStorage.setItem("dismissed-announcement", JSON.stringify(announcementArray))
        announcementElement.style.marginTop = `-${announcementElementHeight}px`
      })

      if (dismissedAnnouncementsList !== null) {
        if (dismissedAnnouncementsList.includes(announcementId)) {
          announcementElement.classList.add("hidden")
        }
      }
    }
  }
}

export default announcements
